import { __assign, __extends } from "tslib";
import React from 'react';
import { utils } from '../utils';
import _ from 'lodash';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import LikeHeart from 'wix-ui-icons-common/on-stage/LikeHeart';
import LikeHeartFill from 'wix-ui-icons-common/on-stage/LikeHeartFill';
var LoveButton = /** @class */ (function (_super) {
    __extends(LoveButton, _super);
    function LoveButton(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleLove = _this.toggleLove.bind(_this);
        _this.state = {
            animate: false,
        };
        return _this;
    }
    LoveButton.prototype.toggleLove = function (e) {
        e.stopPropagation();
        e.preventDefault();
        var item = _.pick(this.props, [
            'layout',
            'type',
            'itemId',
            'id',
            'item',
            'idx',
            'hashtag',
        ]);
        this.props.actions.eventsListener(FULLSCREEN_EVENTS.LOVE_BUTTON_CLICKED, item);
        this.setState({
            animate: !this.props.isLoved,
        });
    };
    LoveButton.prototype.containerClassName = function () {
        switch (this.props.layout) {
            case 'fullscreen':
                return 'fullscreen-social-love-container show-tooltip';
            default:
                return 'block-fullscreen gallery-item-social-love gallery-item-social-button show-tooltip';
        }
    };
    LoveButton.prototype.buttonClasssName = function () {
        var className = [];
        if (this.props.layout === 'fullscreen') {
            className.push('fullscreen-social-love');
        }
        className.push(this.viewClassName());
        className.push('has-custom-focus');
        if (this.props.isLoved) {
            className.push(' pro-gallery-loved');
            className.push(' loved');
        }
        if (this.state.animate) {
            className.push('love-animation');
        }
        return className.join(' ');
    };
    LoveButton.prototype.viewClassName = function () {
        switch (this.props.layout) {
            case 'fullscreen':
                return this.props.device === 'desktop' ? 'fullscreen-icon' : '';
            default:
                return '';
        }
    };
    LoveButton.prototype.counterClassName = function () {
        switch (this.props.layout) {
            case 'fullscreen':
                return ('fullscreen-social-love-count pro-fullscreen-shown ' +
                    this.viewClassName());
            default:
                return ('block-fullscreen gallery-item-social-love-count ' +
                    this.viewClassName());
        }
    };
    LoveButton.prototype.createLoveCounter = function () {
        var count = this.props.loveCount || 0;
        return !!this.props.showCounter && count > 0 ? (React.createElement("i", { "data-hook": "love-counter", className: this.counterClassName() }, count)) : null;
    };
    LoveButton.prototype.getCustomLoveCounter = function () {
        return this.props.customLoveCounterRenderer(this.props.id);
    };
    LoveButton.prototype.render = function () {
        var loveCounter = this.props.customLoveCounterRenderer
            ? this.getCustomLoveCounter()
            : this.createLoveCounter();
        var clickAction = utils.getMobileEnabledClick(this.toggleLove);
        return (React.createElement("span", __assign({ "data-hook": "love-button", className: this.containerClassName() }, clickAction),
            React.createElement("button", { "data-hook": "love-icon", className: this.buttonClasssName(), role: "checkbox", tabIndex: 0, title: "Love", "aria-checked": this.props.isLoved || false }, this.props.isLoved ? React.createElement(LikeHeartFill, null) : React.createElement(LikeHeart, null)),
            loveCounter));
    };
    return LoveButton;
}(React.Component));
export default LoveButton;
//# sourceMappingURL=loveButton.js.map